import React, { useEffect } from 'react';
import { Button } from '@vtbhome/juicyfront';
import { ModalEmployeeListItemMoreInfoProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { DrawerBody, DrawerFooter } from './modal-employee-list-item-more-info.styles';
import { CardUserInfo } from '../../../user/ui/card-user-info/card-user-info';
import { ListContacts } from './list-contacts/list-contacts';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { getUserStatus } from '@shared/lib/utils/get-user-status/get-user-status';
import { useLazyUserPreviewQuery } from '@entities/user/api/user-management-api';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { Modal } from '@shared/ui/modal/modal';

export const ModalEmployeeListItemMoreInfo: React.FC<ModalEmployeeListItemMoreInfoProps> = ({
    isShow,
    userId,
    onClose,
}) => {
    const [getUserPreview, getUserPreviewResult] = useLazyUserPreviewQuery();
    const user = getUserPreviewResult.data;
    const isLoading =
        getUserPreviewResult.isLoading || getUserPreviewResult.isFetching || getUserPreviewResult.isUninitialized;
    const error = getQueryError(getUserPreviewResult);

    useEffect(() => {
        if (userId) {
            getUserPreview(Number(userId));
        }
    }, [userId]);

    return (
        <Modal
            isShow={isShow}
            variant='drawer'
            size='l'
            header={<Typography size='h6'>Информация о сотруднике</Typography>}
            footer={
                <DrawerFooter>
                    <Button buttonType='light' onClick={onClose}>
                        Закрыть
                    </Button>
                </DrawerFooter>
            }
            onClose={onClose}>
            <DrawerBody>
                <NetworkStateNew
                    size='s'
                    isLoading={isLoading}
                    isError={Boolean(error)}
                    isInitialized={Boolean(user) && Number(userId) === user?.id}
                    isFiltered={false}
                    hasData={Boolean(user)}
                    errorProps={{
                        title: 'Ошибка загрузки пользователя',
                        description: error?.message,
                    }}>
                    {user && (
                        <>
                            <CardUserInfo
                                avatarUrl={user.photoUrl || ''}
                                name={
                                    userName({
                                        firstName: user.firstName || '',
                                        lastName: user.lastName || '',
                                        middleName: user.middleName || '',
                                    }).full
                                }
                                organizationPost={user.jobTitle || ''}
                                department={user.department?.name}
                                email={user.email}
                                phone={user.phoneNumber}
                                status={getUserStatus(user)}
                            />
                            <ListContacts email={user.email} phone={user.phoneNumber} />
                        </>
                    )}
                </NetworkStateNew>
            </DrawerBody>
        </Modal>
    );
};
